import { WalkthroughStep } from "./types";

export const WALKTHROUGH_VERSION = "1.0.0";

export const walkthroughSteps: WalkthroughStep[] = [
  {
    id: "welcome",
    title: "Welcome to Ekluvya 👋",
    description:
      "Take a quick tour so you know where everything is. You can explore courses, subjects, chapters, search, profile, and assessment from here.",
    placement: "center",
  },
  {
    id: "choose-course",
    target: '[data-walkthrough="course-selector"]',
    route: "/home/courses",
    title: "Choose any course",
    description:
      "Please choose any course to continue. You’re always free to change it later.",
    placement: "right",
    allowInteraction: true,
    requiresSelection: true,
    selectionMissingMessage: "Please choose a course for further steps.",
  },
  {
    id: "choose-class",
    target: '[data-walkthrough="class-selector"]',
    route: "/home/courses",
    title: "Choose your class",
    description:
      "Please choose your class to continue. This helps us show the right subjects and lessons.",
    placement: "top",
    allowInteraction: true,
    requiresSelection: true,
    selectionMissingMessage: "Please choose a class for further steps.",
  },
  {
    id: "choose-subject",
    target: '[data-walkthrough="subject-selector"]',
    route: "/home/courses",
    title: "Choose a subject",
    description:
      "Please choose any subject to continue. The next steps need a selected subject so we can show chapters properly.",
    placement: "top",
    allowInteraction: true,
    requiresSelection: true,
    selectionMissingMessage: "Please choose a subject for further steps.",
  },
  {
    id: "choose-chapter",
    target: '[data-walkthrough="chapter-selector"]',
    route: "/home/courses",
    title: "Choose a chapter",
    description:
      "Please choose any chapter to continue. The next steps need a selected chapter so we can show teacher videos properly.",
    placement: "top",
    allowInteraction: true,
    requiresSelection: true,
    selectionMissingMessage: "Please choose a chapter for further steps.",
  },
  {
    id: "teacher-videos",
    target: '[data-walkthrough="teacher-videos"]',
    route: "/home/courses",
    title: "Learn from different teachers",
    description:
      "Choose a teacher and play any available lesson. You can learn the same topic from different teachers whenever you like at no additional cost.",
    placement: "top",
    allowInteraction: true,
  },
  {
    id: "nav-search",
    target: '[data-walkthrough="nav-search"]',
    title: "Search",
    description: "Find courses, chapters, topics, and teachers quickly.",
    placement: "left",
    allowInteraction: true,
  },
  {
    id: "nav-profile",
    target: '[data-walkthrough="nav-profile"]',
    title: "Profile",
    description:
      "Manage profiles, preferences, subscription, and help from here. You’re ready to start learning!",
    placement: "bottom",
    allowInteraction: true,
  },
  {
    id: "self-assessment",
    target: '[data-walkthrough="self-assessment"]',
    title: "Free Self Assessment",
    description:
      "Check your understanding with a free self-assessment whenever you’re ready.",
    placement: "bottom",
    allowInteraction: true,
  },
];
